import sourceScenario from '../../../../../simulator-server/src/main/resources/scenarios/pastos-23.json';

/**
 * Dados e rota da demonstração São João, sem dependência de navegador.
 *
 * Separado de `sao-joao-demo.ts` para que os testes ponta a ponta da API usem
 * EXATAMENTE a mesma rota de 12 pontos que o botão da administração salva, sem
 * uma segunda cópia da geometria.
 */
export interface SourcePole { epc: string; order: number; latitude: number; longitude: number }
export interface SourcePasture { id: string; name: string; poles: SourcePole[] }
export interface RoutePoint { readonly latitude: number; readonly longitude: number }

export const SAO_JOAO_SOURCE = sourceScenario as { fences: SourcePasture[]; route: RoutePoint[] };
const SOURCE = SAO_JOAO_SOURCE;

/** Seis passadas longas: ida e volta junto às três faixas de pastos. */
export function saoJoaoRoute(): RoutePoint[] {
  return SOURCE.route.map((point) => ({ ...point }));
}
